/** Ephemeral UI state: toasts and the mobile navigation drawer. */

import { create } from 'zustand';

export interface Toast {
  id: number;
  message: string;
  tone: 'success' | 'info' | 'error';
}

interface UiState {
  toasts: Toast[];
  navOpen: boolean;

  toast: (message: string, tone?: Toast['tone']) => void;
  dismissToast: (id: number) => void;
  setNavOpen: (open: boolean) => void;
}

let seq = 0;

export const useUi = create<UiState>((set, get) => ({
  toasts: [],
  navOpen: false,

  toast: (message, tone = 'success') => {
    const id = (seq += 1);
    set({ toasts: [...get().toasts, { id, message, tone }] });
    window.setTimeout(() => get().dismissToast(id), 3600);
  },

  dismissToast: (id) => set({ toasts: get().toasts.filter((t) => t.id !== id) }),

  setNavOpen: (navOpen) => set({ navOpen }),
}));

/** Callable outside React, so store mutations can report their own outcome. */
export function toast(message: string, tone: Toast['tone'] = 'success') {
  useUi.getState().toast(message, tone);
}
